var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPowerButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 10.915C10.5 11.7434 11.1716 12.415 12 12.415C12.8284 12.415 13.5 11.7434 13.5 10.915V1.5C13.5 0.671573 12.8284 0 12 0C11.1716 0 10.5 0.671573 10.5 1.5V10.915Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.2 11.5329C0.53471 16.1833 2.91899 20.7378 7.11968 22.8409C11.3204 24.944 16.3954 24.1239 19.72 20.8049C22.1642 18.3783 23.3078 14.9334 22.8 11.5269C22.2895 8.06062 20.1612 5.04361 17.067 3.3999C16.595 3.11376 16.004 3.10998 15.5283 3.39005C15.0527 3.67012 14.7693 4.18879 14.7905 4.74035C14.8118 5.29191 15.1342 5.78725 15.63 6.0299C17.8922 7.22502 19.4514 9.42457 19.83 11.9549C20.3189 15.3294 18.5914 18.6377 15.5429 20.1651C12.4944 21.6926 8.81032 21.0957 6.4 18.6839C4.62751 16.925 3.79704 14.428 4.163 11.9579C4.54095 9.42891 6.09907 7.23039 8.36 6.0359C8.83703 5.7822 9.14075 5.29157 9.15513 4.75147C9.16951 4.21137 8.89232 3.70527 8.42947 3.42655C7.96663 3.14783 7.38965 3.13956 6.919 3.4049C3.82928 5.0514 1.70629 8.06865 1.2 11.5329Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerButton);
export default __webpack_public_path__ + "static/media/powerButton.0570d149.svg";
export { ForwardRef as ReactComponent };